module.exports = __webpack_public_path__ + "static/collectorcans-marcus-artwork-cea1f5de432214e86b834567b8eaf7a3.png";